module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/about-183.vue");


//////////////////
// WEBPACK FOOTER
// ./en/vux-loader/about.md
// module id = 623
// module chunks = 471